import type { SyntaxNode } from 'web-tree-sitter';
import type { SymbolImportBinding } from '../../types.js';
import { pushBinding } from './shared.js';

function localNameFromImport(nameNode: SyntaxNode): string {
  return nameNode.text.split('.').at(-1) ?? nameNode.text;
}

function collectImportDeclaration(
  out: SymbolImportBinding[],
  filePath: string,
  workspaceFiles: ReadonlySet<string>,
  node: SyntaxNode,
): void {
  for (const child of node.namedChildren) {
    if (child.type === 'scoped_identifier' || child.type === 'identifier') {
      const sourceName = child.text;
      const localName = localNameFromImport(child);
      pushBinding(out, filePath, workspaceFiles, sourceName, localName, sourceName, 'named', child);
    }
  }
}

export function extractJavaImportBindings(
  root: SyntaxNode,
  filePath: string,
  workspaceFiles: ReadonlySet<string>,
): SymbolImportBinding[] {
  const out: SymbolImportBinding[] = [];
  for (const node of root.descendantsOfType('import_declaration')) {
    collectImportDeclaration(out, filePath, workspaceFiles, node);
  }
  return out;
}
